import React from "react";
import { motion } from "framer-motion";

function Button() {
  return (
    <motion.button
      className="border border-solid border-white md:rounded-lg md:px-[30px]  md:py-[10px]  md:w-[200px] w-[100px] h-[30px] rounded-[6px] md:h-[70px] hover:bg-gray-800 mt-[3%] text-xs md:text-base "
      onClick={() => {
        window.open(
          "mailto:qozeemopeyemi2008@gmail.com?subject=SendMail&body=Description"
        );
      }}
      //   initial={{ x: "-100vw", scale: 1.5 }}
      //   animate={{ scale: 1, x: 0 }}
      transition={{ type: "spring", stiffness: 250 }}
      whileHover={{
        scale: 1.1,
        textShadow: "0px 0px 8px rgb(255, 255, 255)",
        boxShadow: "0px 0px 8px rgb(255, 255, 255)",
      }}
    >
      Hire Me!
    </motion.button>
  );
}

export default Button;
